module.exports = __webpack_public_path__ + "static/customize_7-3979cf3322dae087563f80c5abfd1eda.png";